<div class="col d-flex flex-column justify-content-center align-items-center h-100">
	<h1>Enter a new password</h1>
	<div id="input-wrapper">
		<form [formGroup]="form" (submit)="resetPassword()">
			<div class="form-group">
				<mat-form-field appearance="outline" class="w-100">
					<mat-label>Old Password</mat-label>
					<input matInput placeholder="Old Password" type="password" formControlName="oldPassword" />
					@if (form.controls.oldPassword.errors?.required) {
						<mat-error>Old password is required</mat-error>
					}
				</mat-form-field>
				@if (wrongPassword) {
					<mat-error class="invalid-error">Invalid password</mat-error>
				}
			</div>
			<div class="form-group">
				<mat-form-field appearance="outline" class="w-100">
					<mat-label>Password</mat-label>
					<input matInput placeholder="Password" type="password" formControlName="password" />
					@if (form.controls.password.errors?.required) {
						<mat-error>Password is required</mat-error>
					}
				</mat-form-field>
			</div>
			<div class="form-group">
				<mat-form-field appearance="outline" class="w-100">
					<mat-label>Confirm Password</mat-label>
					<input matInput placeholder="Confirm Password" type="password" formControlName="confirmPassword" />
					@if (form.controls.confirmPassword.errors?.required) {
						<mat-error>Confirm Password is required</mat-error>
					}
				</mat-form-field>
				@if (passwordMismatch) {
					<mat-error class="invalid-error">The passwords don't match</mat-error>
				}
			</div>
			<button type="submit" mat-flat-button color="primary" [disabled]="loading">Change Password</button>
		</form>
	</div>
</div>
